import { render, staticRenderFns } from "./CommentComponent.vue?vue&type=template&id=4502f9d1"
import script from "./CommentComponent.vue?vue&type=script&lang=js"
export * from "./CommentComponent.vue?vue&type=script&lang=js"
import style0 from "./CommentComponent.vue?vue&type=style&index=0&id=4502f9d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports